import { Icon, Tooltip, typography } from '@joor/design-system'
import styled from 'styled-components/macro'

export const TOOLTIP_CONTENT =
  'This information is pulled from the products in this order and cannot be edited.'

export default function DetailFormItem({
  title,
  content,
  isEditable,
  ownTooltipText,
}: Props) {
  return (
    <div>
      <HeaderWrapper>
        <Title>{title}</Title>
        {!isEditable && (
          <Tooltip
            testId={DetailFormItemTestIds.Tooltip}
            defaultPlacement="right"
            content={ownTooltipText ?? TOOLTIP_CONTENT}
            customTooltipStyles={{ 'margin-top': '-3px' }}
          >
            <StyledIcon iconName="information" iconSize="small" />
          </Tooltip>
        )}
      </HeaderWrapper>
      {content}
    </div>
  )
}

type Props = {
  title: string
  content: React.ReactNode
  isEditable?: boolean
  ownTooltipText?: string
}

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
`

const Title = styled.p`
  ${typography.alpha.primaryActive.body3}
  line-height: 16px !important;
  margin-bottom: 0 !important;
`

const StyledIcon = styled(Icon)`
  svg {
    --main-color: var(--color-secondary-800);
  }
`

export const DetailFormItemTestIds = {
  Tooltip: 'DetailFormItemTooltip',
} as const
